<div class="app-main__inner">

  <!-- ========== LIST VIEW ========== -->
  <app-member-list-panel
    *ngIf="view === 'list'"
    [showAddButton]="isAdmin || isManager"
    (addRequested)="addNew()"
    (editRequested)="editRecord($event)">
  </app-member-list-panel>

  <!-- ========== FORM VIEW ========== -->
  <div *ngIf="view === 'form'" class="bb-form-view">
    <div class="bb-form-card">

      <div class="bb-form-header">
        <div class="bb-form-header__title">
          <i class="pe-7s-user"></i>
          {{ isEditMode ? 'Edit Member' : 'New Member' }}
        </div>
        <button type="button" class="bb-form-header__back" (click)="backToList()">
          <i class="pe-7s-angle-left"></i> Back
        </button>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <div class="bb-form-body">

          <!-- ── Personal ───────────────────────────────────────────── -->
          <div class="bb-form-section">Personal</div>
          <div class="row g-2 align-items-start">
            <div class="col-md-3">
              <label class="form-label">Full Name <span class="text-danger">*</span></label>
              <input type="text" formControlName="name" class="form-control"
                     [class.is-invalid]="isFieldInvalid('name')" placeholder="Enter full name" />
              <div class="invalid-feedback">
                <span *ngIf="f['name'].errors?.['required']">Full name is required.</span>
                <span *ngIf="f['name'].errors?.['minlength']">Min 2 characters.</span>
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label">Primary Phone No. <span class="text-danger">*</span></label>
              <div class="input-group">
                <span class="input-group-text">+91</span>
                <input type="tel" formControlName="phone" class="form-control"
                       [class.is-invalid]="isFieldInvalid('phone')"
                       placeholder="10-digit mobile" maxlength="10" />
              </div>
              <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('phone')">
                <span *ngIf="f['phone'].errors?.['required']">Phone is required.</span>
                <span *ngIf="f['phone'].errors?.['invalidPhone']">Valid 10-digit number required.</span>
              </div>
              <div class="form-check mt-1">
                <input class="form-check-input" type="checkbox" formControlName="phone1wa" id="phone1wa" />
                <label class="form-check-label bb-wa-label" for="phone1wa">On WhatsApp</label>
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label">Secondary Phone No.</label>
              <div class="input-group">
                <span class="input-group-text">+91</span>
                <input type="tel" formControlName="phone2" class="form-control"
                       [class.is-invalid]="isFieldInvalid('phone2')"
                       placeholder="10-digit mobile" maxlength="10" />
              </div>
              <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('phone2')">
                <span *ngIf="f['phone2'].errors?.['invalidPhone']">Valid 10-digit number required.</span>
              </div>
              <div class="form-check mt-1">
                <input class="form-check-input" type="checkbox" formControlName="phone2wa" id="phone2wa" />
                <label class="form-check-label bb-wa-label" for="phone2wa">On WhatsApp</label>
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label">Max Books <span class="text-danger">*</span></label>
              <input type="number" formControlName="maxBooksAllowed" class="form-control"
                     [class.is-invalid]="isFieldInvalid('maxBooksAllowed')"
                     placeholder="1–20" min="1" max="20" />
              <div class="invalid-feedback">
                <span *ngIf="f['maxBooksAllowed'].errors?.['required']">Required.</span>
                <span *ngIf="f['maxBooksAllowed'].errors?.['min'] || f['maxBooksAllowed'].errors?.['max']">1–20 only.</span>
              </div>
            </div>
          </div>

          <!-- ── Address ────────────────────────────────────────────── -->
          <div class="bb-form-section">Address</div>
          <div class="row g-2">
            <div class="col-md-4">
              <label class="form-label">Area / Locality</label>
              <div class="d-flex gap-1 align-items-start">
                <select class="form-select" [class.is-invalid]="isFieldInvalid('area')"
                        formControlName="area">
                  <option value="">— Select area —</option>
                  <option *ngIf="f['area'].value && !uniqueAreas.includes(f['area'].value)"
                          [value]="f['area'].value">{{ f['area'].value }}</option>
                  <option *ngFor="let a of uniqueAreas" [value]="a">{{ a }}</option>
                </select>
                <button type="button" class="bb-add-area-btn" (click)="openAddAreaDialog()" title="Add new area">
                  <i class="pe-7s-plus"></i>
                </button>
              </div>
            </div>
            <div class="col-md-5">
              <label class="form-label">Landmark</label>
              <input type="text" formControlName="landmark" class="form-control"
                     [class.is-invalid]="isFieldInvalid('landmark')" placeholder="Nearby landmark" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Pincode</label>
              <input type="text" formControlName="pincode" class="form-control"
                     [class.is-invalid]="isFieldInvalid('pincode')" placeholder="6-digit" maxlength="6" />
              <div class="invalid-feedback">Valid 6-digit pincode required.</div>
            </div>
            <div class="col-md-8">
              <label class="form-label">Full Address</label>
              <textarea formControlName="address" class="form-control"
                        [class.is-invalid]="isFieldInvalid('address')"
                        rows="2" placeholder="Enter complete address"></textarea>
              <div class="invalid-feedback">Max 300 characters.</div>
            </div>
            <div class="col-md-4">
              <label class="form-label">Member Type <span class="text-danger">*</span></label>
              <div class="d-flex flex-row gap-3 pt-1 flex-wrap">
                <div class="form-check" *ngFor="let mt of memberTypes">
                  <input class="form-check-input" type="radio" formControlName="memberType"
                         [id]="'mt_' + mt.value" [value]="mt.value" />
                  <label class="form-check-label" [for]="'mt_' + mt.value">{{ mt.label }}</label>
                </div>
              </div>
              <div *ngIf="isHomeDelivery" class="mt-2">
                <select formControlName="locationId" class="form-select form-select-sm"
                        [class.is-invalid]="isFieldInvalid('locationId')">
                  <option value="">— Select Route —</option>
                  <option *ngFor="let r of routes" [value]="r._id">{{ r.routeid }} — {{ r.description }}</option>
                </select>
                <div class="invalid-feedback">Route is required for Door Delivery.</div>
                <div class="form-text" *ngIf="routes.length === 0">No routes available.</div>
              </div>
            </div>
          </div>

          <!-- ── Membership ─────────────────────────────────────────── -->
          <div class="bb-form-section">Membership</div>

          <!-- Row 1: dates + amounts -->
          <div class="row g-2 align-items-end">
            <div class="bb-date-col">
              <label class="form-label">Start Date <span class="text-danger">*</span></label>
              <input type="date" formControlName="memberSince" class="form-control form-control-sm"
                     [class.is-invalid]="isFieldInvalid('memberSince')" />
            </div>
            <div class="bb-dur-col">
              <label class="form-label">Duration <span *ngIf="!isEditMode" class="text-danger">*</span></label>
              <select *ngIf="!isEditMode" formControlName="membershipDurationMonths"
                      class="form-select form-select-sm"
                      [class.is-invalid]="isFieldInvalid('membershipDurationMonths')"
                      (change)="onNewMemberPlanChange()">
                <option *ngFor="let p of subscriptionPlans" [value]="p.months">
                  {{ p.label || p.months + ' Month(s)' }}
                </option>
                <option *ngIf="subscriptionPlans.length === 0" [value]="12">12 Months</option>
              </select>
              <input *ngIf="isEditMode" type="text" class="form-control form-control-sm bg-light"
                     [value]="editDisplaySubscriptionType || '—'" readonly tabindex="-1" />
            </div>
            <div class="bb-date-col">
              <label class="form-label">Active Till</label>
              <input type="text" class="form-control form-control-sm bb-active-till"
                     [value]="computedExpiry" readonly tabindex="-1" />
            </div>
            <div class="bb-amt-col">
              <label class="form-label">Fee (₹)</label>
              <input type="number" class="form-control form-control-sm bg-light" [value]="displayFee ?? ''"
                     readonly tabindex="-1" />
            </div>
            <div class="bb-amt-col">
              <label class="form-label">Deposit (₹)</label>
              <input type="number" class="form-control form-control-sm bg-light" [value]="displayDeposit"
                     readonly tabindex="-1" />
            </div>
            <div class="bb-date-col">
              <label class="form-label">Payment Date</label>
              <input type="date" class="form-control form-control-sm"
                     [(ngModel)]="newMemberPaymentDate" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="bb-date-col" *ngIf="displayDeposit > 0 || isEditMode">
              <label class="form-label">Deposit Date</label>
              <input type="date" formControlName="depositDate" class="form-control form-control-sm" />
            </div>
            <div class="bb-status-col" *ngIf="isEditMode">
              <label class="form-label">Membership Status</label>
              <select formControlName="status" class="form-select form-select-sm">
                <option value="MEMBER">Active (MEMBER)</option>
                <option value="OnHold">On Hold</option>
                <option value="Due">Due / Expired</option>
              </select>
            </div>
            <div class="bb-date-col" *ngIf="isEditMode && f['status'].value === 'OnHold'">
              <label class="form-label">On Hold Till</label>
              <input type="date" formControlName="onHoldTill" class="form-control form-control-sm" />
            </div>
          </div>

          <!-- Payment details — last line -->
          <div class="row g-2 mt-1">
            <div class="col-md-3">
              <label class="form-label">Mode of Payment</label>
              <select class="form-select form-select-sm" [(ngModel)]="newMemberPaymentMode"
                      [ngModelOptions]="{standalone: true}">
                <option *ngFor="let m of paymentModes" [value]="m">{{ m }}</option>
              </select>
            </div>
            <div class="col-md-5">
              <label class="form-label">Reference / Trnx ID</label>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="newMemberPaymentTrnxRef"
                     [ngModelOptions]="{standalone: true}" placeholder="UPI ref / Chq no / etc." />
            </div>
            <div class="col-md-4">
              <label class="form-label">Remarks</label>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="newMemberPaymentRemarks"
                     [ngModelOptions]="{standalone: true}" placeholder="Optional" />
            </div>
          </div>

        </div>

        <div class="bb-form-footer">
          <div class="bb-form-footer__msg">
            <span *ngIf="errorMessage" class="text-danger"><i class="pe-7s-close-circle me-1"></i>{{ errorMessage }}</span>
            <span *ngIf="successMessage" class="text-success"><i class="pe-7s-check me-1"></i>{{ successMessage }}</span>
          </div>
          <button type="button" class="bb-btn-reset" *ngIf="!isEditMode"
                  (click)="form.reset({ memberSince: todayString(), maxBooksAllowed: 5, memberType: 'A', locationId: '', isActive: true, phone1wa: false, phone2: '', phone2wa: false, status: 'MEMBER', onHoldTill: '' })">
            <i class="pe-7s-refresh"></i> Reset
          </button>
          <button type="submit" class="bb-btn-save" [disabled]="form.invalid || isSaving">
            <span *ngIf="!isSaving"><i class="pe-7s-diskette"></i> {{ isEditMode ? 'Update Member' : 'Save Member' }}</span>
            <span *ngIf="isSaving" class="d-flex align-items-center gap-1"><span class="spinner-border spinner-border-sm"></span> Saving...</span>
          </button>
        </div>
      </form>

    </div>
  </div>

</div>

<!-- ── Add New Area popup ─────────────────────────────── -->
<div *ngIf="showAddArea"
     class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
     style="background:rgba(0,0,0,.45);z-index:1060;"
     (click)="cancelAddArea()">
  <div class="card shadow-lg" style="width:360px;max-width:95vw;" (click)="$event.stopPropagation()">
    <div class="card-header d-flex align-items-center justify-content-between py-2 px-3">
      <span class="fw-bold small"><i class="pe-7s-map-marker me-2 text-primary"></i>Add New Area</span>
      <button class="btn-close" (click)="cancelAddArea()"></button>
    </div>
    <div class="card-body p-3">
      <label class="form-label">Area / Locality Name <span class="text-danger">*</span></label>
      <input type="text" class="form-control" [(ngModel)]="newAreaName"
             placeholder="e.g. Koregaon Park"
             (keyup.enter)="confirmAddArea()" autofocus />
      <div class="form-text">This area will be added to the dropdown and selected.</div>
    </div>
    <div class="card-footer d-flex justify-content-end gap-2 py-2 px-3">
      <button type="button" class="btn btn-secondary btn-sm" (click)="cancelAddArea()">Cancel</button>
      <button type="button" class="btn btn-primary btn-sm" (click)="confirmAddArea()" [disabled]="!newAreaName.trim()">
        <i class="pe-7s-check me-1"></i>Add & Select
      </button>
    </div>
  </div>
</div>
